import { render, staticRenderFns } from "./Year23.vue?vue&type=template&id=6ca9c840"
import script from "./Year23.vue?vue&type=script&lang=js"
export * from "./Year23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports